import { render, staticRenderFns } from "./operationalStatistics.vue?vue&type=template&id=3dd8d7bd&scoped=true"
import script from "./operationalStatistics.vue?vue&type=script&lang=js"
export * from "./operationalStatistics.vue?vue&type=script&lang=js"
import style0 from "./operationalStatistics.vue?vue&type=style&index=0&id=3dd8d7bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8d7bd",
  null
  
)

export default component.exports